<template>

  <div class="input radio-buttons">

    <label :for="name" v-html="label"></label>
    <div class="opts">
      <template v-for="opt in optsParsed">
        <div class="radio-opt">
          <input type="radio" :name="name" :id="name+'_'+opt.toLowerCase()" :value="opt.toLowerCase()">
          <label :for="name+'_'+opt.toLowerCase()">{{opt}}<span class="radio"></span></label>
        </div>
      </template>
    </div>

  </div>

</template>

<style lang="scss" scoped>
  .input.radio-buttons {
    .opts,
    label {
      box-sizing: border-box;
      float: left;
    }
    label {
      width: 75%;
    }
    .opts {
      width: 25%;
      text-align: right;
    }
  }
  /* Customize the label (the container) */
  .radio-opt {
    display: inline-block;
    position: relative;
    padding-left: 1.5rem;
    margin-bottom: 0.75rem;
    margin-right: 0.75rem;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    &:last-child {
      margin-right: 0;
    }
    label {
     cursor: pointer;
     padding-left: 1rem;
    }
  }

  /* Hide the browser's default checkbox */
  .radio-opt input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  /* Create a custom checkbox */
  .radio {
    position: absolute;
    top: 0;
    left: 0;
    height: 1.5625rem;
    width: 1.5625rem;
    background-color: #FFFFFF;
    border-radius: 50%;
    border: 0.0625rem solid #CBCBCB;
  }

  /* On mouse-over, add a grey background color */
  .radio-opt:hover input + label .radio {
    background-color: #EEEEEE;
  }

  /* When the checkbox is checked, add a blue background */
  .radio-opt input:checked + label .radio {
    background-color: #FFFFFF;
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .radio::after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  .radio-opt input:checked + label .radio::after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .radio-opt .radio::after {
    left: 0.5rem;
    top: 0.125rem;
    width: 0.4375rem;
    height: 1rem;
    border: solid #5E94D4;
    border-width: 0 0.25rem 0.25rem 0;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  @media only screen and (max-width: 570px) {
    .input.radio-buttons {
      > label,
      .opts {
        width: 100%;
        float: none;
      }
      .opts {
        text-align: left;
        margin-top: 1rem;
      }
    }
  }
</style>

<script>
  export default {
    name: 'Radio',
    props: ['label', 'name', 'opts'],
    data () {
      return {
        optsParsed : this.opts.split('|'),
      }
    },
    mounted() {

    },
    methods: {

    }
  }
</script>
